import { useEffect } from 'react';

import { PaletteModeEnum } from '@e-socna/data-layer';
import type { PaletteModeId } from '@e-socna/data-layer';

import { useAuthenticationContext } from '../contexts/AuthenticationContext/hooks/useAuthenticationContext.hook';
import { useReferencesContext } from '../contexts/ReferencesContext/hooks/useReferencesContext.hook';
import { useUiSettingsContext } from '../contexts/UiSettingsContext/hooks/useUiSettingsContext.hook';

export const SyncUiSettings = () => {
  const { authenticationData } = useAuthenticationContext();
  const { paletteModesIdMap } = useReferencesContext();
  const { setUiSettings } = useUiSettingsContext();

  const uiSettings = authenticationData?.uiSettings;
  const paletteMode =
    paletteModesIdMap[uiSettings?.paletteModeId as PaletteModeId]?.code ??
    PaletteModeEnum.Light;
  const themeMainColor = uiSettings?.themeMainColor;
  const isContextualColorEnabled = uiSettings?.isContextualColorEnabled ?? true;

  useEffect(() => {
    setUiSettings({ paletteMode, themeMainColor, isContextualColorEnabled });
  }, [isContextualColorEnabled, paletteMode, setUiSettings, themeMainColor]);

  return null;
};
